import React from "react"

import { useSchedule } from "@shared/contexts"

export default function KakaoPlusFriendButton() {
  const { schedule } = useSchedule()

  const kakaoPlusFriendUrl = schedule?.user.kakaoPlusFriendUrl

  if (!kakaoPlusFriendUrl) {
    return null
  }

  return (
    <li className="kakao">
      <a
        href={kakaoPlusFriendUrl}
        title="친구추가"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i>-</i>친구추가
      </a>
    </li>
  )
}
